export default {
  SET_GRID_DATA_GRID_SAMPLE(state, params) {
    state.gridData = params;
  },

  SET_PROJECT_LIST_GRID_SAMPLE(state, params) {
    state.projectList = params;
  },
};



// WEBPACK FOOTER //
// ./src/vuex/sample/gridSample/gridSampleMutation.js